<template>
<svg viewBox="0 0 25 25" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-PingLunMian`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M23.1245 12.9685C23.1245 18.9702 18.2591 23.8355 12.2573 23.8355C10.0122 23.8355 7.92604 23.1547 6.19414 21.9882L3.73056 22.6958C2.96668 22.9152 2.26447 22.1988 2.49906 21.4395L3.23638 19.0528L3.28276 19.0983C2.08862 17.3534 1.39014 15.2425 1.39014 12.9685C1.39014 6.96687 6.25554 2.10156 12.2573 2.10156C18.2591 2.10156 23.1245 6.96687 23.1245 12.9685ZM15.9125 18.0195C16.303 17.712 16.3703 17.1461 16.0628 16.7556C15.7552 16.3651 15.1894 16.2978 14.7989 16.6053C12.7379 18.2281 10.5251 17.3262 9.75967 16.6416C9.38918 16.3102 8.82022 16.3419 8.48885 16.7124C8.15748 17.0829 8.18918 17.6518 8.55967 17.9832C9.75048 19.0483 12.9515 20.351 15.9125 18.0195Z"/></svg>
</template>
<script>

export default {
  name: 'IconPingLunMian',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
